//Generated File 
export default class AIChatMessageType{
	static readonly Assistant = `Assistant`;
	static readonly System = `System`;
	static readonly ToolExecutionResult = `ToolExecutionResult`;
	static readonly User = `User`;
}
